var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeEllipseHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5182 2.65982C10.449 1.53556 11.8726 0.799988 13.4879 0.799988C16.2972 0.799988 18.575 2.9801 18.575 5.66887C18.575 7.56453 16.3063 9.4857 16.3063 9.4857L9.50005 16L2.6938 9.4857C2.6938 9.4857 0.425049 7.56453 0.425049 5.66887C0.425049 2.9801 2.70287 0.799988 5.51215 0.799988C7.12694 0.799988 8.55058 1.53556 9.48247 2.65982C9.48814 2.6533 9.49438 2.64733 9.50005 2.64082C9.50515 2.64679 9.51196 2.6533 9.5182 2.65982Z",
    fill: "#2A7F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeEllipseHover);
export default __webpack_public_path__ + "static/media/likeEllipseHover.d8d388dbd2d8eb5e788bd717dcd88c97.svg";
export { ForwardRef as ReactComponent };